<div  *ngIf="extend !== null; else loadExtend">

  
        <h2 class="col-12">Confirmer la prolongation</h2>
        <h4 class="col-12">Nouvelles Dates</h4>
        <div class="col-12">
          <div class="row">
            <div class="col-4">
              <label>
                <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
                Début de reservation
              </label>
            </div>
            <div class="col-4">
            </div>
            <div class="col-4">
              <label>
                <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
                Fin de reservation
              </label>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-5">
              {{_start}}
            </div>
            <div class="col-2">
              <mat-icon aria-hidden="false" aria-label="Example home icon">trending_flat</mat-icon>
            </div>
            <div class="col-5">
              {{_end}}
            </div>
          </div>
        </div>
        <h4 class="col-12 text-center">Modifaction du prix</h4>
        <div class="col-12">
          <div class="row">
            <div class="col-4">
              Prix initial
            </div>
            <div class="col-4">
              prix de la prolongation
            </div>
            <div class="col-4">
              Nouveau prix
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-3">
              {{_extend.initial_price }}
            </div>
            <div class="col-3">
              +
            </div>
            <div class="col-3">
              {{_extend.additional_price }}
            </div>
            <div class="col-3">
              = {{_extend.final_price }}
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row justify-content-around">
              <button class="col-sm-4 align-self-end" color="primary"  mat-stroked-button
              (click)="cancel()">Retour</button>
              <button class="col-sm-4 align-self-end" color="primary"  mat-flat-button
              (click)="confirm();">Confirmer</button>
          </div>
        </div>
</div>
<ng-template #loadExtend></ng-template>

